"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const with_editable_field_1 = require("./with-editable-field");
const query_select_1 = require("../query-select");
exports.EditableQuerySelect = with_editable_field_1.withEditableField(query_select_1.QuerySelect);
